module.exports = __webpack_public_path__ + "img/aa39f94.svg";